import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "@shopify/polaris";
import translations from "@shopify/polaris/locales/en.json";
import AdminPage from "./components/AdminPage";
import AppBridgeProvider from "./components/AppBridgeProvider";
import "@shopify/polaris/build/esm/styles.css";

const App = () => {
  return (
    <Router>
      <AppProvider i18n={translations}>
        <AppBridgeProvider>
          <AdminPage />
        </AppBridgeProvider>
      </AppProvider>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
